// extracted by mini-css-extract-plugin
export default {"Subscribebox":"subscribe_Subscribebox__LiR7j","formWrapmain":"subscribe_formWrapmain__EbxrU","formWrap":"subscribe_formWrap__BfVMx","marginbotton":"subscribe_marginbotton__MEDUV"};